<template>
    <PopoverRight ref="popoverContent" width="500px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">编辑内容项</h1>
            <p class="remark">1、动态取值字段请用<span class="red">[标签名]</span>表示，如<span class="red">[城市]</span> 在长沙站生成导购文章内展示为：长沙，广州站生成导购文章内展示为：广州。</p>
            <p class="remark">2、支持动态取值的字段名称及取值示范，可点击<span @click="showTagLib" style="color:rgb(0 85 245);cursor: pointer;">“动态取值标签库”</span>  进行查看。</p>
            <el-form class="form-container" :model="content" ref="contentValidateForm">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">文章类型</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item >
                            <el-select v-model="content.type" placeholder="全部">
                                <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id" disabled ></el-option>
                            </el-select>                        
                        </el-form-item>
                    </div>
                </div>
                 <div class="form-item">
                    <div class="form-label">
                        <span class="label">内容项</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item >
                            <el-select v-model="content.body_type" placeholder="全部">
                                    <el-option v-for="item in bodyType" :key="item.id" :label="item.name" :value="item.id" disabled ></el-option>
                                </el-select>                   
                        </el-form-item>
                    </div>
                </div>
                <template v-if="content.body_type == 1">
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">标题</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                            <el-form-item 
                                prop="body" 
                                :rules="titleRule"
                            >
                                <el-input placeholder="[城市][楼盘名称]好不好？" class="input-control" v-model="content.body"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </template>
                <template v-if="content.body_type == 2">
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">关键字</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                                <el-tag
                                    class="topic-tag"
                                    v-model="cntTags"
                                    v-for="(tag,index) in cntTags"
                                    :key="index"
                                    closable
                                    :disable-transitions="false"
                                    @close="handleClose(tag)"
                                    >{{ tag }}</el-tag
                                >
                                <template v-if="cntTags.length < 4" >
                                    <el-input
                                    class="input-new-tag"
                                    v-if="inputVisible"
                                    v-model="inputValue"
                                    ref="saveTagInput"
                                    size="small"
                                    @keyup.enter.native="handleInputConfirm()"
                                    @blur="handleInputConfirm()"
                                    >
                                    </el-input>
                                    <el-button
                                    v-else
                                    class="button-new-tag"
                                    size="small"
                                    @click="showInput()"
                                    >+ 添加关键字</el-button
                                    >
                                </template>
                        </div>
                    </div>
                </template>
                 <template v-if="content.body_type == 3">
                        <div class="form-item">
                            <div class="form-label">
                                <span class="label">正文</span>
                                <label class="warn">*</label>
                            </div>
                            <div class="form-input-item">
                                <el-form-item 
                                    prop="body" 
                                    :rules="bodyRule"
                                >
                                    <el-input type="textarea" minlength="1" maxlength="1000" placeholder="请输入正文内容" class="input-control" v-model="content.body"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                </template>
                <div class="align-center">
                    <el-button @click="hideMenu">取消</el-button>
                    <el-button type="primary" @click="submitForm('contentValidateForm')">提交</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>
<script>
import PopoverRight from '@/components/popoverRight/index'
import { NEWS_MODEL } from "@/config/index";
import {editNewsCnt,getCntDetail} from '@/service/newsModel'

export default {
    name: 'edit',
    components: {
        PopoverRight
    },
    props: {
        callback: Function,
        size: Number
    },
    data () {
      
        return {
            content:{
                type:'',
                body_type:'',
                body:''
            },
            typeList:[],
            bodyType:[],
            cntTags:[],
            typeKey:"title",
            typeName:"标题",
            inputVisible:false,
            inputValue: "",
            isClear: false,
            titleRule: [
                { required: true, message: '标题不能为空', trigger: 'blur' },
                { min: 1, max: 50, message: '标题为1-50个字符之间', trigger: 'blur' },
            ],
            bodyRule: [
                { required: true, message: '正文不能为空', trigger: 'blur' },
                { min: 1, max: 1000, message: '正文为1-1000个字符之间', trigger: 'blur' },
            ],

        }
    },
    mounted(){
        this.typeList = NEWS_MODEL.news_types;
        this.bodyType = NEWS_MODEL.body_type;
    },
    methods: {
        /** 打开右侧悬浮层 */
        openMenu (id) {
            this.$refs.popoverContent && this.$refs.popoverContent.open()
            this.getDetail(id)
        },
        /** 关闭右侧悬浮层 */
        hideMenu () {
            this.$refs.popoverContent && this.$refs.popoverContent.hide()
            this.$refs.contentValidateForm && this.$refs.contentValidateForm.clearValidate()
            this.resetForm()
        },
        getDetail(id){
            getCntDetail(id).then((data) => {
                this.content = data;
                if(data.body_type == 1){
                    this.typeKey = "title";
                    this.typeName = "标题";
                }else if(data.body_type  == 2){
                    this.typeKey = "title";
                    this.typeName = "关键词";
                    this.cntTags = data.body.split(',')
                }else{
                    this.typeKey = "body";
                    this.typeName = "正文";
                }
            })
        },
        handleClose(tag) {
        this.cntTags.splice(this.cntTags.indexOf(tag), 1);
        },
        showInput() {
            this.inputVisible = true;
            this.$nextTick((_) => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue && inputValue.length <= 10) {
            this.cntTags.push(inputValue);
            
            this.inputVisible =false;
            this.inputValue = "";
        } else if (inputValue == "") {
            this.inputValue = "";
        } else {
            this.$message({
            type: "error",
            message: "关键词最多10个字符",
            });
            return false;
        }
        },
   
        showTagLib(){
            this.$emit("showTagLib")
        },
        resetForm () {
            this.content = {}
            this.cntTags=[];
        },
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) return null
                if(this.content.body_type == 2){
                    if(!this.cntTags.length>0){
                        this.$message({
                            type: "error",
                            message: "关键词不能为空",
                        });
                        return;
                    }
                    this.content.body = this.cntTags.join(",")
                }
                editNewsCnt(this.content.id,this.content).then((data) => {
                   this.$message({
                        type: "success",
                        message: "编辑"+this.typeName+"成功",
                    });
                    this.hideMenu();
                    this.callback && this.callback()
                })
                .catch((err) => {
                    this.$message({
                        type: "error",
                        message: err.message || "编辑失败",
                    });
                });

            })
        },
    }
}
</script>
<style scoped>
.form-input-item .el-tag /deep/ .el-icon-close {
  display: inline-block !important;
  border-radius: 50%;
  text-align: center;
  position: relative !important;
  cursor: pointer;
  font-size: 12px !important;
  height: 16px !important;
  width: 16px !important;
  line-height: 16px !important;
  vertical-align: middle;
  top: -1px !important;
  right: -5px !important;

}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: auto;
  margin-left: 10px;
  vertical-align: bottom;
}
.remark{
    font-size: 14px;
    padding-top: 10px;
    line-height:30px;
    color: #666;
}
.red{
    color:red;
}
</style>